import React, { useEffect } from 'react';
import BackButton from '../../components/common/BackButton/BackButton';
import './PrivacyPolicy.css';

export default function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="legal-page-container">
      <div style={{ marginBottom: '16px' }}>
        <BackButton fallbackTo="/" />
      </div>

      <header className="legal-header">
        <span className="legal-badge">Legal Documentation</span>
        <h1 className="legal-title">Privacy Policy</h1>
        <p className="legal-meta">Last Updated: October 2026 • Tiwari Syndicate Private Limited</p>
      </header>

      <div className="legal-intro-box">
        <strong>Tiwari Syndicate</strong> ("we", "our", or "us") is dedicated to protecting your privacy. This Privacy Policy outlines our standards and practices regarding the collection, handling, storage, and protection of your personal and business information when you use our website, services, and construction product ordering systems.
      </div>

      <div className="legal-content-grid">
        <section className="legal-section-card">
          <div className="legal-section-header">
            <span className="legal-section-num">1</span>
            <h2 className="legal-section-title">Information We Collect</h2>
          </div>
          <div className="legal-body">
            <p>We collect information to provide superior product quotations, material sourcing, order dispatches, and customer support. This includes:</p>
            <ul className="legal-list">
              <li><strong>Personal Identifiers:</strong> Name, phone number, email address, postal address, and business or project site location.</li>
              <li><strong>Business & Order Details:</strong> Company/firm name, GSTIN (if applicable), billing details, contractor license details, and material purchase history.</li>
              <li><strong>Communications:</strong> Inquiries, callback requests, quotes, WhatsApp interactions, and support ticket records.</li>
              <li><strong>Device & Browsing Data:</strong> IP address, browser type, operating system, pages viewed, and access timestamps collected through standard server logs and secure cookies.</li>
            </ul>
          </div>
        </section>

        <section className="legal-section-card">
          <div className="legal-section-header">
            <span className="legal-section-num">2</span>
            <h2 className="legal-section-title">How We Use Your Information</h2>
          </div>
          <div className="legal-body">
            <p>We use the collected information strictly for operational and business purposes, including:</p>
            <ul className="legal-list">
              <li>Processing, verifying, and fulfilling material orders, quotes, and shipments.</li>
              <li>Arranging dispatch, transport, and delivery to designated job sites or warehouses.</li>
              <li>Providing timely customer support, callback responses, and technical assistance on building materials.</li>
              <li>Issuing tax invoices, delivery challans, and maintaining statutory accounting records.</li>
              <li>Protecting against unauthorized transactions, fraud, and system misuse.</li>
            </ul>
          </div>
        </section>

        <section className="legal-section-card">
          <div className="legal-section-header">
            <span className="legal-section-num">3</span>
            <h2 className="legal-section-title">Information Sharing & Third Parties</h2>
          </div>
          <div className="legal-body">
            <p><strong>We do not sell, rent, or trade your personal information.</strong> We only share necessary data with trusted third parties under strict confidentiality:</p>
            <ul className="legal-list">
              <li><strong>Logistics & Transport Partners:</strong> Necessary shipping addresses and contact details are provided to delivery teams and carriers to deliver goods.</li>
              <li><strong>Financial Institutions & Payment Gateways:</strong> For processing secure digital payments and credit checks where authorized.</li>
              <li><strong>Legal & Regulatory Authorities:</strong> When required by applicable Indian laws, tax regulations, court orders, or governmental requests.</li>
            </ul>
          </div>
        </section>

        <section className="legal-section-card">
          <div className="legal-section-header">
            <span className="legal-section-num">4</span>
            <h2 className="legal-section-title">Data Security & Storage</h2>
          </div>
          <div className="legal-body">
            <p>We implement robust physical, technical, and administrative safeguards to protect your personal and transaction records:</p>
            <ul className="legal-list">
              <li>Data transmission over encrypted channels via SSL/TLS protocol.</li>
              <li>Restricted, role-based database access limited strictly to authorized operations personnel.</li>
              <li>Regular security monitoring and secure backup procedures.</li>
            </ul>
          </div>
        </section>

        <section className="legal-section-card">
          <div className="legal-section-header">
            <span className="legal-section-num">5</span>
            <h2 className="legal-section-title">Your Rights & Choices</h2>
          </div>
          <div className="legal-body">
            <p>You have the right to access, review, update, or request correction of any personal data stored with us. You may also opt-out of promotional communications at any time by contacting our support desk or using the unsubscribe options in our messages.</p>
          </div>
        </section>

        <section className="legal-section-card">
          <div className="legal-section-header">
            <span className="legal-section-num">6</span>
            <h2 className="legal-section-title">Cookies and Tracking</h2>
          </div>
          <div className="legal-body">
            <p>Our website uses necessary session cookies to maintain your login credentials, shopping cart, and theme preferences. You may adjust your browser settings to refuse cookies, though certain interactive features of our catalog may be limited as a result.</p>
          </div>
        </section>

        <div className="legal-contact-card">
          <h4>Questions Regarding This Privacy Policy?</h4>
          <p style={{ margin: '0 0 8px 0', fontSize: '14px', lineHeight: '1.6' }}>
            If you have questions, feedback, or requests concerning your data privacy, please contact our team:
          </p>
          <div style={{ fontSize: '14px', lineHeight: '1.8' }}>
            <strong>Tiwari Syndicate Private Limited</strong><br />
            Address: Tiwari Syndicate Private Limited, Majhauli Khetal, Near Majhaulia Chowk, Majhaulia, Muzaffarpur, Bihar, 842001<br />
            Phone: 0621-406 9248 / +91 7667158891<br />
            Email: <a href="mailto:enquiry@tiwarisyndicate.com" style={{ color: 'inherit', fontWeight: '600' }}>enquiry@tiwarisyndicate.com</a>
          </div>
        </div>
      </div>
    </div>
  );
}
